module.exports = function getResource(label, vars = []) {
    let resources = {
        reset: 'Reset',
        filter: 'filter'
    };
    return resources[label];
};
